import styled from 'styled-components';

/* ------------------------------------------------------------------------ */
/* ----------------------------- Table styles ----------------------------- */
/* ------------------------------------------------------------------------ */
const Table = styled.table`
  border-collapse: collapse;
  font-family: ${(props) => props.theme.fontSourceSansPro};
  width: 100%;
`;

const TableFooter = styled.div`
  align-items: center;
  color: ${(props) => props.theme.grayMedium};
  display: flex;
  flex-direction: row;
  font-size: 0.625rem;
  min-height: ${(props) => props.theme.rowHeight};
  justify-content: space-between;
  padding: 0.296875rem 1.125rem;

  @media screen and (min-width: ${(props) => props.theme.md}) {
    font-size: 0.825rem;

    /* ----- Small-width Hub ----- */
    .election-hub--min & {
      font-size: 0.625rem;
    }

    .election-hub--race-card__with-photos & {
      padding: 0.296875rem 1.125rem 0.296875rem 3.3125rem;
    }
  }

  .election-hub--min .election-hub--race-card__with-photos & {
    padding: 0.296875rem 1.125rem;
  }

  strong {
    font-weight: 700;
  }

  div {
    max-width: 70%;
    text-align: left;
    vertical-align: baseline;
  }

  /* ----- Force reporting div to right align always ----- */
  .election-hub--reporting {
    margin-left: auto;
    text-align: right;

    svg {
      fill: ${(props) => props.theme.grayDarkest};
      height: 11px;
      margin-right: 5px;
      width: 11px;
      vertical-align: -1px;
    }
  }
`;

/* eslint-disable max-len */
const TableHeader = styled.th`
  color: ${(props) => props.theme.black};
  font-size: 0.75rem;
  font-weight: 400;
  text-align: ${(props) => props.alignText || 'center'};
  width: 100%;

  .election-hub__info-header & {
    border-bottom: 1px solid ${(props) => props.theme.borderColor};
    font-family: ${(props) => props.theme.fontSourceSerifPro};
    font-weight: bold;
    line-height: 1.875rem;
    padding: 0.296875rem 0;

    /* ----- Style middle rows ----- */
    &:not(:last-child):not(:first-child) {
      padding: 0.296875rem 2.25rem;

      /* ----- Small-width Hub ----- */
      .election-hub--min & {
        padding: 0.296875rem 0;
      }
    }

    @media screen and (min-width: ${(props) => props.theme.md}) {
      font-size: 0.95rem;
      padding: 0.296875rem 1.125rem;

      .election-hub--race-card__with-photos &:first-child {
        padding: 0.296875rem 1.125rem 0.296875rem 3.3125rem;
      }
    }

    /* ----- Small-width Hub ----- */
    .election-hub--min & {
      font-size: 0.95rem;
      padding: 0.296875rem 1.125rem;

      &:last-child {
        padding: 0.296875rem 1.125rem 0.296875rem 0.625rem;
      }
    }

    .election-hub--min .election-hub--race-card__with-photos &:first-child {
      padding: 0.296875rem 1.125rem;
    }
  }

  .candidate__first-name, .candidate__last-name {
    font-size: 0.825rem;
  }
`;
/* eslint-enable max-len */

const TableCell = styled.td`
  font-size: 0.75rem;
  font-weight: 400;
  /* This line height hack is required to make the rows fully collapse */
  line-height: 0;
  padding: 0 0.625rem;
  text-align: ${(props) => props.alignText || 'center'};
  vertical-align: middle;

  @media screen and (min-width: ${(props) => props.theme.md}) {
    font-size: 0.875rem;
  }

  /* ----- Small-width Hub ----- */
  .election-hub--min & {
    font-size: 0.75rem;
  }

  /* ----- Party Percentage ----- */
  &.election-hub__percentage {
    font-size: 0.825rem;
    font-weight: 700;

    /* ----- Party Colors ----- */
    .party__democrat & {
      color: ${(props) => props.theme.democrat};
    }
    .party__republican & {
      color: ${(props) => props.theme.republican};
    }
  }

  /* ----- Party Electoral Votes ----- */
  &.party__electoral-votes {
    font-weight: 700;
  }
`;

const TableRow = styled.tr`
  border-bottom: 1px solid ${(props) => props.theme.borderColor};

  /* ----- Race cards ------ */
  &.candidate__winner {
    background-color: ${(props) => props.theme.offWhite};
  }

  &.candidate__winner.party__democrat {
    background-color: ${(props) => props.theme.democratLight};
  }
  &.candidate__winner.party__republican {
    background-color: ${(props) => props.theme.republicanLight};
  }

  /* ----- Ballot Measure cards ----- */
  &.measure__yes--winner,
  &.measure__no--winner {
    background-color: ${(props) => props.theme.offWhite};
  }

  .election-hub--desktop{
    font-size: 0.875rem;
  }

  td:last-child {
    text-align: right;
    padding: 0 1.125rem;

    @media screen and (min-width: ${(props) => props.theme.md}) {
      /* ----- Small-width Hub ----- */
      .election-hub--min & {
        padding: 0 1.125rem 0 0.625rem;
      }

      .election-hub--race-card__with-photos & {
        padding: 0 1.125rem;
      }

      .election-hub--min .election-hub--race-card__with-photos & {
        padding: 0 1.125rem 0 0.625rem;
      }
    }
  }
`;

export default {
  Table,
  TableCell,
  TableFooter,
  TableHeader,
  TableRow,
};
